﻿import InputCheckbox from '../InputCheckbox/InputCheckbox'
import { Customer } from './CustomerInfo'

interface CustomerFlaggedCardProps {
  customer: Customer
  onFlagToggle: (isFlagged: boolean) => void
  flagError: boolean
}

const CustomerFlaggedCard = ({ customer, onFlagToggle, flagError }: CustomerFlaggedCardProps) => {
  return (
    <div className='flex flex-col gap-3'>
      <div className='flex items-center pt-4'>
        <label className='customer-info__ban-text my-0 ml-0 mr-2'>Flagga kund</label>
        <div className='ml-auto'>
          <InputCheckbox
            id='flag-checkbox'
            checked={!!customer.customerFlag}
            onCheckChanged={(e) => onFlagToggle(e.target.checked)}
          />
        </div>
      </div>
      {flagError && <p className='text-[var(--color-accent-red)]'>Det gick inte att flagga kunden</p>}
      {customer.sessions?.some(s => s.isSessionFlagged) && <span className='customer-info__ban-subtext'>Ett eller flera kundvarv är flaggade</span>}
    </div>
  )
}

export default CustomerFlaggedCard
